import check_order_get_date from "@/views/check_order/modules/check_order_get_date";
export default (context, timestamp) => {
    context.total = timestamp - (new Date(new Date().getTime() - (((-new Date().getTimezoneOffset() - 180) * 60) * 1000)));

    // считаем секунды
    let seconds = Math.floor((context.total / 1000) % 60);
    context.date_text.seconds.value = seconds > 0 ? seconds : 0
    context.date_text.seconds.text = context.declination(seconds > 0 ? seconds : 0, ['секунда', 'секунды', 'секунд'])
    context.seconds = seconds >= 10 ?  String(seconds) : String(`0${seconds > 0 ? seconds : 0}`)

    // считаем минуты
    let minutes = Math.floor((context.total / 1000 / 60) % 60);
    context.date_text.minutes.value =  minutes > 0 ? minutes : 0
    context.date_text.minutes.text = context.declination(minutes > 0 ? minutes : 0, ['минута', 'минуты', 'минут'])
    context.minutes = minutes >= 10 ? String(minutes) : String(`0${minutes > 0 ? minutes : 0}`)

    // считаем все часы
    let all_hours = Math.floor((context.total / (1000 * 60 * 60)));

    // считаем все дни
    let all_days = Math.floor(context.total / (1000 * 60 * 60 * 24))

    // склоняем вывод дней
    context.date_text.days.value = all_days > 0 ? all_days : 0
    context.date_text.days.text = context.declination(all_days > 0 ? all_days : 0, ['день', 'дня', 'дней'])

    // считаем часы
    let hours = (all_hours > 0 ? all_hours : 0)  - ((all_days > 0 ? all_days : 0) * 24)

    // склоняем вывод часов
    context.date_text.hours.value = hours > 0 ? hours : 0
    context.date_text.hours.text = context.declination( hours > 0 ? hours : 0, ['час', 'часа', 'часов'])

    // устанавливаем формат для вывода времени
    context.hours = hours >= 10 ? String(hours) : String(`0${hours > 0 ? hours : 0}`)
    context.days = all_days >= 10 ? String(all_days) : String(`0${all_days > 0 ? all_days : 0}`)

    if(context.total >= 0) {
        context.interval = setTimeout(() => {
            context.is_timer = true
            check_order_get_date(context, timestamp)
        }, 1000)
    } else {
        context.seconds = '00'
        context.minutes = '00'
        context.hours = '00'
        context.is_timer = false
    }
}